var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 131,
    viewBox: "0 0 103 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0753 64.6487L40.6946 65.5545L38.5439 72.216L41.9247 71.3101L44.0753 64.6487ZM41.9247 71.3101L60.6042 66.3049L62.7548 59.6435L44.0753 64.6487L41.9247 71.3101Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0753 76.1799L40.6946 77.0858L38.5439 83.7472L41.9247 82.8413L44.0753 76.1799ZM41.9247 82.8413L60.6042 77.8362L62.7548 71.1748L44.0753 76.1799L41.9247 82.8413Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 79.6228C99 105.179 78.7141 126.012 53.3173 126.967C52.7137 126.987 52.1102 127 51.5 127C50.8898 127 50.3191 126.987 49.7286 126.967C24.3122 126.038 4 105.199 4 79.6228V79.564C4 73.4987 8.9337 68.5719 15.0155 68.5719C21.0974 68.5719 26.0376 73.4987 26.0376 79.564C26.0376 79.6686 26.0376 79.7668 26.0311 79.8649H26.0376C26.0376 89.9606 31.9489 98.6823 40.4976 102.772V53.5036H33.0183C26.9365 53.5036 22.0028 48.5833 22.0028 42.5115C22.0028 36.4397 26.9365 31.5194 33.0183 31.5194H40.4976V14.9855C40.4976 8.92026 45.4313 4 51.5197 4C57.6081 4 62.5418 8.92026 62.5418 14.9855V31.5194H70.0735C76.1619 31.5194 81.0956 36.4397 81.0956 42.5115C81.0956 48.5833 76.1619 53.5036 70.0735 53.5036H62.5418V102.752C71.0708 98.6561 76.9624 89.9475 76.9624 79.8649H76.9689C76.9624 79.7864 76.9624 79.7014 76.9624 79.6228C76.9624 73.551 81.8961 68.6308 87.9845 68.6308C94.0729 68.6308 99 73.551 99 79.6228Z",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPort);
export default __webpack_public_path__ + "static/media/port.83475b7c8f38e3a20f4ebd1a78a59954.svg";
export { ForwardRef as ReactComponent };